<template>
    <div class="more-answer-wrapper" :class="{ 'can-hide-mode': !isEmpty }">
        <div class="widget-title" v-if="isEmpty">{{ selectLabel }}</div>
        <Button v-if="!isEmpty" :text="addLabel" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="addClick" class="add-btn" />
        <div class="widget-thumbnails" :class="{ 'can-hide-mode': !isEmpty }" v-if="isShowWidget">
            <ul class="thumb-list">
                <li v-for="(tb, idx) in widgets" class="thumbnail" :key="idx" @click="widgetClick(tb)">
                    <i class="thumb-icon" :style="{ background: tb.icon }"></i>
                    <div class="thumb-text">{{ tb.text }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import i18n from "@/i18n";
import { checkModule } from "@/lib/auth";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";

export default {
    name: "AnswerMore",
    props: ["isEmpty"],
    components: {
        Button
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px 0",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px -22px",
            widgetShow: false
        };
    },
    computed: {
        isShowWidget() {
            return this.isEmpty || this.widgetShow;
        },
        selectLabel() {
            return this.$t("zhiji.answer.selectWidgets");
        },
        addLabel() {
            return this.$t("zhiji.answer.addWidget");
        },
        widgets() {
            let widgets = getWidgets(this.zhiji.staticPath());
            if (isPubg() && !this.isContentBase) {
                // pubg只有内容助手需要全量的组件
                widgets = widgets.filter(item => {
                    return item.wtType != "Picture" && item.wtType != "HList" && item.wtType != "Guides" && item.wtType != "Video";
                });
            }

            return widgets;
        },
        isContentBase() {
            return this.$store.state.zhiji.gameState.gameId === "80002" ? true : false;
        }
    },
    methods: {
        addClick() {
            this.widgetShow = !this.widgetShow;
        },
        widgetClick(widget) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addContent",
                wtType: widget.wtType
            });
            widget.wtType === "Form" ? this.getFromType() : "";
            this.widgetShow = false;
        },
        getFromType() {
            this.$store.dispatch("zhiji/getFormTypeList", {
                page: 1,
                size: 10,
                status: 1, // 只关联正常状态的表单
                classId: ""
            });
        },
        windowClick(event) {
            if (this.isShowWidget && !this.isEmpty && this.zhiji.isClickOuter(event, "more-answer-wrapper")) {
                this.widgetShow = false;
            }
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};

function getWidgets(staticPath) {
    const formWidget = {
        wtType: "Form",
        icon: "url('" + staticPath + "ico-mod-form.png') no-repeat",
        text: i18n.t("zhiji.answer.form")
    };
    const defautWidgets = [
        {
            wtType: "PlatTextLink",
            icon: "url('" + staticPath + "ico-mod-txt.png') no-repeat",
            text: i18n.t("zhiji.answer.text")
        },
        {
            wtType: "HotRecommend",
            icon: "url('" + staticPath + "icon-hot-recommand.png') no-repeat",
            text: i18n.t("zhiji.answer.hotRecom")
        },
        // {
        //     wtType: "Tool",
        //     icon: "url('" + staticPath + "icon-tool.png') no-repeat",
        //     text: i18n.t("zhiji.answer.tools")
        // },
        {
            wtType: "Picture",
            icon: "url('" + staticPath + "ico-mod-img.png') no-repeat",
            text: i18n.t("zhiji.answer.picture")
        },
        {
            wtType: "HList",
            icon: "url('" + staticPath + "ico-mod-list.png') no-repeat",
            text: i18n.t("zhiji.answer.hList")
        }
        // {
        //     wtType: "Package",
        //     icon: "url('" + staticPath + "ico-mod-gift.png') no-repeat",
        //     text: i18n.t("zhiji.answer.package")
        // }
    ];

    checkModule("ticket") && defautWidgets.splice(1, 0, formWidget);

    return defautWidgets;
}
</script>

<style lang="scss" scoped>
.more-answer-wrapper {
    position: relative;
    width: max-content;
    margin-bottom: 120px;

    &.can-hide-mode {
        margin-left: 48px;
        margin-top: 16px;
    }

    .widget-title {
        font-size: 14px;
        margin: 20px 0 12px 12px;
        font-weight: bold;
    }

    .widget-thumbnails {
        margin-left: 12px;

        &.can-hide-mode {
            position: absolute;
            bottom: -110px;
            z-index: 1;
            left: 0;
            max-width: 608px;
            width: max-content;
            padding: 16px 8px 8px 16px;
            margin: 12px 0 0 0;
            margin-left: 0;
            background: #fff;
            border-radius: 4px;
            box-sizing: border-box;
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        }
    }

    .thumb-list {
        font-size: 0;
        padding: 0;
        .thumb-text {
            padding: 5px;
        }
    }

    .thumbnail {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        margin: 0 8px 8px 0;
        min-width: 65px;
        height: 65px;
        border: 1px solid #d8e4f0;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        }
    }

    .thumb-icon {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-top: 8px;
    }
}
</style>
